__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/c2e5d08/_next/";